export default "__VITE_ASSET__adf3542c__"